import DocusaurusFooter from '../DocusaurusFooter'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { environments } from '../../docs-routes'

const EnvironmentSelect = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      You must select an execution environment to view snippets.
    </Color>
    <DocusaurusFooter path={environments} />
  </Paragraph>

export default EnvironmentSelect
